import * as React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import TeamMemberArchiveUserModal from '../../containers/team-members/TeamMemberArchiveUserModal'
import TeamMemberCreateForm from '../../containers/team-members/TeamMemberCreateForm'
import TeamMemberEditPane from '../team-members/form/TeamMemberEditPane'
import TeamMemberResetPasswordModal from '../../containers/team-members/TeamMemberResetPasswordModal'
import TeamMemberSendInviteModal from '../../containers/team-members/TeamMemberSendInviteModal'
import TeamMemberTablePane from '../../containers/team-members/TeamMemberTablePane'
import TeamMemberViewPane from '../../containers/team-members/TeamMemberViewPane'
import ErrorBoundary from '../ErrorBoundary'

const TeamMemberTableRoute = () => <TeamMemberTablePane />

const TeamMemberListPane = ({ match }: RouteComponentProps<{}>) => {
  return (
    <div>
      <Route exact={true} path={match.path} component={TeamMemberTableRoute} />
      <Route path={`${match.path}/:id/archive`} component={TeamMemberArchiveUserModal} />
      <Route path={`${match.path}/:id/reset-password`} component={TeamMemberResetPasswordModal} />
      <Route path={`${match.path}/:id/send-invite`} component={TeamMemberSendInviteModal} />
    </div>
  )
}

const TeamMemberPane = ({ match }: RouteComponentProps<{}>) => {
  return (
    <ErrorBoundary>
      <Route path={`/team-members/edit/:id/`} component={TeamMemberEditPane} />
      <Switch>
        <Route path={`${match.path}/create`} component={TeamMemberCreateForm} />
        <Route path={`${match.path}/:id`} component={TeamMemberViewPane} />
        <Route exact={true} path={`${match.path}`} component={TeamMemberListPane} />
      </Switch>
    </ErrorBoundary>
  )
}

export default TeamMemberPane



// WEBPACK FOOTER //
// ./src/components/team-members/TeamMemberPane.tsx